/** 各フェーズ定義 */
export const PHASE = {
  /** 待機状態: エアー抜き開始確認 */
  WAIT: 'wait',
  /** 待機状態: エアー抜き準備確認 */
  START: 'start',
  /** 実行状態: 注意表示(右前輪) */
  RIGHT_FRONT_CAUTION: 'rightFrontCaution',
  /** 実行状態: エアー抜き(N/O・N/C弁強制駆動)(右前輪) */
  RIGHT_FRONT_NO_NC_VALVE: 'rightFrontNoNcValve',
  /** 実行状態: エアー抜き(ブリーダーバルブ開閉操作指示)(右前輪) */
  RIGHT_FRONT_BLEEDER_VALVE: 'rightFrontBleederValve',
  /** 実行状態: エアー抜き(ブリーダーバルブ開閉操作指示)確認後(右前輪)  */
  RIGHT_FRONT_BLEEDER_VALVE_CONFIRMED: 'rightFrontBleederValveConfirmed',
  /** 実行状態: エアー抜き(エアー抜き実施)(右前輪) */
  RIGHT_FRONT_EXECUTE_BLEEDING: 'rightFrontExecuteBleeding',
  /** 実行状態: 注意表示(左前輪) */
  LEFT_FRONT_CAUTION: 'leftFrotnCaution',
  /** 実行状態: エアー抜き(N/O・N/C弁強制駆動)(左前輪) */
  LEFT_FRONT_NO_NC_VALVE: 'leftFrontNoNcValve',
  /** 実行状態: エアー抜き(ブリーダーバルブ開閉操作指示)(左前輪) */
  LEFT_FRONT_BLEEDER_VALVE: 'leftFrontBleederValve',
  /** 実行状態: エアー抜き(ブリーダーバルブ開閉操作指示)確認後(右前輪)  */
  LEFT_FRONT_BLEEDER_VALVE_CONFIRMED: 'leftFrontBleederValveConfirmed',
  /** 実行状態: エアー抜き(エアー抜き実施)(左前輪) */
  LEFT_FRONT_EXECUTE_BLEEDING: 'leftFrontExecuteBleeding',
  /** 実行状態: 開始確認(右後輪) */
  RIGHT_REAR_START: 'rightRearStart',
  /** 実行状態: 準備(右後輪) */
  RIGHT_REAR_PREPARATION_1: 'rightRearPreparation1',
  /** 実行状態: 実行(エアー抜き)(右後輪) */
  RIGHT_REAR_EXECUTE_BLEEDING_1: 'rightRearExecuteBleeding1',
  /** 実行状態: エアー抜き2回目:準備(右後輪) */
  RIGHT_REAR_PREPARATION_2: 'rightRearPreparation2',
  /** 実行状態: 実行(エアー抜き2回目)(右後輪) */
  RIGHT_REAR_EXECUTE_BLEEDING_2: 'rightRearExecuteBleeding2',
  /** 実行状態: 準備(左後輪) */
  LEFT_REAR_PREPARATION_1: 'leftRearPreparation1',
  /** 実行状態: 実行(エアー抜き)(左後輪) */
  LEFT_REAR_EXECUTE_BLEEDING_1: 'leftRearExecuteBleeding1',
  /** 実行状態: エアー抜き2回目:準備(左後輪) */
  LEFT_REAR_PREPARATION_2: 'leftRearPreparation2',
  /** 実行状態: 実行(エアー抜き2回目)(左後輪) */
  LEFT_REAR_EXECUTE_BLEEDING_2: 'leftRearExecuteBleeding2',
  /** 実行状態: 実行確認 */
  EXECUTE_CONFIRMATION: 'executeConfirmation',
  /** 実行状態: エアー抜きシーケンス2 */
  AIR_BLEEDING_SEQ_2: 'airBleedingSeq2',
  /** 実行状態: エアー抜きシーケンス3 */
  AIR_BLEEDING_SEQ_3: 'airBleedingSeq3',
  /** 実行状態: 開始確認 */
  START_CONFIRMATION: 'startConfirmation',
  /** 実行状態: エアー抜き実行(7回目) */
  AIR_BLEEDING_7: 'airBleeding7',
  /** 停止: エアー抜き完了表示 */
  AIR_BLEEDING_COMPLETED: 'airBleedingCompleted',
  /** エラー */
  ERROR: 'error',
  /** 共通エラー */
  FAILED: 'failed'
};

const HEADER_COLORS = {
  DANGER: 'danger',
  SUCCESS: 'success',
  SECONDARY: 'secondary'
};

const HEADER_TITLES = {
  CONFIRMATION: 'message.common_title_confirmation',
  EXECUTION: 'individual.common_title_execution',
  SUCCESS: 'message.common_title_success',
  ERROR: 'message.common_title_error'
};

// phase毎の情報
export const PHASE_INFO = {
  [PHASE.WAIT]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.CONFIRMATION },
  [PHASE.START]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.CONFIRMATION },
  [PHASE.RIGHT_FRONT_CAUTION]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.RIGHT_FRONT_NO_NC_VALVE]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.RIGHT_FRONT_BLEEDER_VALVE]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.RIGHT_FRONT_BLEEDER_VALVE_CONFIRMED]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.RIGHT_FRONT_EXECUTE_BLEEDING]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.LEFT_FRONT_CAUTION]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.LEFT_FRONT_NO_NC_VALVE]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.LEFT_FRONT_BLEEDER_VALVE]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.LEFT_FRONT_BLEEDER_VALVE_CONFIRMED]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.LEFT_FRONT_EXECUTE_BLEEDING]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.RIGHT_REAR_START]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.RIGHT_REAR_PREPARATION_1]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.RIGHT_REAR_EXECUTE_BLEEDING_1]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.RIGHT_REAR_PREPARATION_2]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.RIGHT_REAR_EXECUTE_BLEEDING_2]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.LEFT_REAR_PREPARATION_1]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.LEFT_REAR_EXECUTE_BLEEDING_1]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.LEFT_REAR_PREPARATION_2]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.LEFT_REAR_EXECUTE_BLEEDING_2]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.EXECUTE_CONFIRMATION]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.AIR_BLEEDING_SEQ_2]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.AIR_BLEEDING_SEQ_3]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.START_CONFIRMATION]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.AIR_BLEEDING_7]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.AIR_BLEEDING_COMPLETED]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.ERROR]: { headerColor: HEADER_COLORS.DANGER, headerTitle: HEADER_TITLES.ERROR },
  [PHASE.FAILED]: { headerColor: HEADER_COLORS.DANGER, headerTitle: HEADER_TITLES.ERROR },
};
